export default "__VITE_ASSET__aK5O9Exy__"